import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { AuthorizationCheckRequired, eventBus, PmStore } from "@/state";



let queryGetLegalEntity = gql`
  query legalEntity($organizationId: UUID!, $legalEntityId: UUID!) {
    legalEntity(organizationId: $organizationId, legalEntityId: $legalEntityId) {
      id
      address_id
      address
      company_type_id
      company_type
      ein
      name
      name_of_controller
      name_of_owner
      phone_number_of_controller
      phone_number_of_owner
      
      owner_email
      controller_email
      
      
      
     }
  }
`;



let mutationSetLegalEntityAddress = gql`
  mutation setLegalEntityAddress($organizationId: UUID!, $legalEntityId: UUID!, $addressId: UUID) {
    setLegalEntityAddress(organizationId: $organizationId, legalEntityId: $legalEntityId, addressId: $addressId) 
  }  
`;




let queryLegalEntities = gql`
  query legalEntities($organizationId: UUID!) {
    legalEntities(organizationId: $organizationId) {
      id
      address_id
      company_type_id
      ein
      name
      name_of_controller
      name_of_owner
      phone_number_of_controller
      phone_number_of_owner
     }
  }
`;




export var mutationSetLegalEntityEin = gql`
  mutation setLegalEntityEin($organizationId: UUID!, $legalEntityId: UUID!, $ein: String) {
    setLegalEntityEin(organizationId: $organizationId, legalEntityId: $legalEntityId,  ein: $ein) 
  }  
`;





export function useLegalEntityActions() {
    const state = PmStore();
    const [apiLegalEntities] = useLazyQuery(queryLegalEntities);
    const [apiGetLegalEntity] = useLazyQuery(queryGetLegalEntity);
    const [apiSetLegalEntityAddress] = useMutation(mutationSetLegalEntityAddress);
    const [apiSetLegalEntityEin] = useMutation(mutationSetLegalEntityEin);



    function SetLegalEntityEin(legalEntityId: string, ein : string) {
        let organizationId = state?.selectedOrganization?.id;
        return new Promise(async (resolve, reject) => {
            apiSetLegalEntityEin({variables: {organizationId, legalEntityId, ein}})
            .then((result: any) => result?.data?.setLegalEntityEin)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                if (err.name === 'AbortError') {
                // Handle aborted request gracefully
                return;
                }

                toast.error("Api Error, Unable to set legal entity EIN");
                reject(err);
            })
        })
    }



    function SetLegalEntityAddress(legalEntityId: string, addressId : string) {
        let organizationId = state?.selectedOrganization?.id;
        return new Promise(async (resolve, reject) => {
            apiSetLegalEntityAddress({variables: {organizationId, legalEntityId, addressId}})
            .then((result: any) => result?.data?.setLegalEntityAddress)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                if (err.name === 'AbortError') {
                // Handle aborted request gracefully
                return;
                }

                toast.error("Api Error, Unable to set legal entity address!");
                reject(err);
            })
        })
    }


    function GetLegalEntities() {
        let organizationId = state?.selectedOrganization?.id;
        return new Promise(async (resolve, reject) => {
            apiLegalEntities({variables: {organizationId}})
            .then((result: any) => result?.data?.legalEntities)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                if (err.name === 'AbortError') {
                    // Handle aborted request gracefully
                    return;
                  }

                toast.error("Api Error, Unable to legal entity!");
                reject(err);
            })
        })
    }


    function GetLegalEntity(legalEntityId: string) {
        let organizationId = state?.selectedOrganization?.id;
        return new Promise(async (resolve, reject) => {
            apiGetLegalEntity({variables: {organizationId, legalEntityId}})
            .then((result: any) => result?.data?.legalEntity)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                if (err.name === 'AbortError') {
                    // Handle aborted request gracefully
                    return;
                  }

                toast.error("Api Error, Unable to legal entity!");
                reject(err);
            })
        })
    }

    
    return {
        GetLegalEntities,
        GetLegalEntity,
        SetLegalEntityAddress,
        SetLegalEntityEin
        
        // GetApplicationStatuses: (orgId) => GetLookupGroupValues(orgId, "application_status")

    };
}




